module.exports = __webpack_public_path__ + "img/search.145d00bc.svg";